import { jsxs, jsx } from "react/jsx-runtime";
import { TextButton, Box } from "@zillow/constellation-10";
import { IconChevronDownOutline } from "@zillow/constellation-icons";
import { yieldCallback } from "@zillow/yield-callback";
import { useState } from "react";
import { getCmsInfoForPage } from "../../utils/clickstream/getCmsInfoForPage.esm.js";
import { sendEvent } from "./B2BUserNav.utils.esm.js";
import SignOut from "./SignOut.esm.js";
import { usePageProps } from "@zillow/cms-utils";
const SignIn = ({
  user,
  // signInLink can be realtive (starts with "/") or it can omit this starting
  // "/"
  signInLink,
  redirectParam,
  env,
  router,
  inverse,
  userMenuItems
}) => {
  const pageProps = usePageProps();
  const cmsInfo = getCmsInfoForPage(pageProps);
  const domain = env === "prod" ? "https://www.zillow.com" : "https://www.qa.zillow.net";
  const [dropdown, setDropdown] = useState(false);
  const signOutURL = domain + "/Logout.htm";
  const redirectUrl = domain + router.asPath;
  let signInURL;
  const isSignInLinkWithDomain = signInLink.startsWith("https");
  if (isSignInLinkWithDomain) {
    signInURL = new URL(signInLink);
  } else {
    signInURL = new URL(domain);
    signInURL.pathname = signInLink;
  }
  signInURL.searchParams.append(redirectParam, redirectUrl);
  const onMouseEnter = () => {
    setDropdown(true);
  };
  const onMouseLeave = () => {
    setDropdown(false);
  };
  if (user) {
    return /* @__PURE__ */ jsxs(TextButton, { tone: "neutral", onImpact: inverse, textStyle: "body-sm", "aria-label": "Account Menu", "aria-expanded": dropdown, "data-dropdown-open": dropdown ? "" : void 0, onMouseEnter, onMouseLeave, onClick: yieldCallback(() => {
      setDropdown(!dropdown);
    }), icon: /* @__PURE__ */ jsx("span", { style: !inverse && dropdown ? {
      color: "#0041D9"
    } : void 0, children: /* @__PURE__ */ jsx(IconChevronDownOutline, {}) }), iconPosition: "end", css: {
      position: "relative",
      color: inverse ? "text.onImpact.neutral-fixed" : void 0,
      ...inverse ? {} : {
        // On pointer devices, label turns blue on hover
        "@media (hover: hover)": {
          '&:hover [data-c11n-component="TextButton.Label"]': {
            color: "text.accent.brand.hero"
          }
        },
        // On touch devices, suppress underline flash during tap
        "@media (hover: none)": {
          '&:hover [data-c11n-component="TextButton.Label"]': {
            textDecoration: "none !important"
          },
          '&:focus [data-c11n-component="TextButton.Label"]': {
            textDecoration: "none !important"
          }
        }
      }
    }, children: [
      dropdown && /* @__PURE__ */ jsx(Box, { css: {
        top: 0,
        left: "-24px",
        right: "-16px",
        bottom: "-200px",
        position: "absolute",
        zIndex: "popover"
      } }),
      /* @__PURE__ */ jsx(Box, { asChild: true, css: {
        textDecoration: "none",
        color: "inherit",
        smDown: {
          display: "none"
        }
      }, children: /* @__PURE__ */ jsx("span", { style: !inverse && dropdown ? {
        color: "#0041D9"
      } : void 0, children: [user.firstName, user.lastName].filter(Boolean).join(" ") || "My Account" }) }),
      /* @__PURE__ */ jsx(Box, { asChild: true, css: {
        display: "none",
        textDecoration: "none",
        color: "inherit",
        smDown: {
          display: "block"
        }
      }, children: /* @__PURE__ */ jsx("span", { style: !inverse && dropdown ? {
        color: "#0041D9"
      } : void 0, children: "My Account" }) }),
      /* @__PURE__ */ jsx(SignOut, { url: signOutURL, dropdown, userMenuItems })
    ] });
  } else if (user === false) {
    return /* @__PURE__ */ jsx(TextButton, { tone: "neutral", onImpact: inverse, textStyle: "body-sm", asChild: true, children: /* @__PURE__ */ jsx("a", { href: signInURL.href, onClick: yieldCallback(() => {
      sendEvent("cms_anchor", "Sign In", signInURL.href, cmsInfo);
    }), children: "Sign In" }) });
  } else {
    return null;
  }
};
export {
  SignIn as default
};
